<ng-container >
    <div class="background" *ngIf="show">
      <div class="card">
        <div class="wait">
          <img src="/assets/images/bs_loader.gif" alt="procesando..." />
          <!-- <div class="footer">Espere por favor...</div> -->
        </div>
      </div>
    </div>
  </ng-container>
